import React from 'react';

const VIDEO_EXTS = ['mp4', 'webm', 'mov', 'ogg', 'mkv'];

export const isVideoUrl = (url) => {
    if (!url) return false;
    const ext = url.split('.').pop().toLowerCase().split('?')[0];
    return VIDEO_EXTS.includes(ext);
};

const UserAvatar = ({ src, alt = 'img', className = '', style = {}, onClick }) => {
    if (isVideoUrl(src)) {
        return (
            <video
                src={src}
                className={className}
                style={{ objectFit: 'cover', display: 'block', maxWidth: '100%', ...style }}
                onClick={onClick}
                autoPlay
                loop
                muted
                playsInline
            />
        );
    }
    return (
        <img
            src={src || '/images/default.png'}
            alt={alt}
            className={className}
            style={style}
            onClick={onClick}
        />
    );
};

export default UserAvatar;
